var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-zoomer"},[(_vm.loading || _vm.loadingTypes)?_c('div',{staticClass:"loader-svg"},[_c('Loader')],1):_vm._e(),_c('div',{attrs:{"id":"svgEmbed"}})])}
var staticRenderFns = []

export { render, staticRenderFns }